import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M393-739.999h426.999v242.307H393v-242.307zm426.999 277.691v242.307H624.691v-242.307h195.308zm-426.999 0h196.307v242.307H393v-242.307zM140.001-220.001v-519.998h217.615v519.998H140.001z"
      ></path>
    </svg>
  );
}

export default Icon;
